import { render, staticRenderFns } from "./c_home_intergral.vue?vue&type=template&id=4b969664&scoped=true"
import script from "./c_home_intergral.vue?vue&type=script&lang=js"
export * from "./c_home_intergral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b969664",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城平台端\\fhj-web-dyh-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b969664')) {
      api.createRecord('4b969664', component.options)
    } else {
      api.reload('4b969664', component.options)
    }
    module.hot.accept("./c_home_intergral.vue?vue&type=template&id=4b969664&scoped=true", function () {
      api.rerender('4b969664', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfig/c_home_intergral.vue"
export default component.exports